import {
  getFirestore, doc, getDoc, setDoc, deleteDoc, collection,
  query, where, getDocs, getCountFromServer, serverTimestamp,
} from 'firebase/firestore';
import { app } from './firebase';

const db = app ? getFirestore(app) : null;
const followId = (a, b) => `${a}__${b}`;

export async function isFollowing(followerUid, followedUid) {
  if (!db || !followerUid) return false;
  const snap = await getDoc(doc(db, 'follows', followId(followerUid, followedUid)));
  return snap.exists();
}

export async function followUser(follower, followedUid) {
  if (!db) return;
  await setDoc(doc(db, 'follows', followId(follower.uid, followedUid)), {
    followerUid: follower.uid,
    followedUid,
    followerName: follower.displayName || null,
    followerPhoto: follower.photoURL || null,
    createdAt: serverTimestamp(),
  });
}

export async function unfollowUser(followerUid, followedUid) {
  if (!db) return;
  await deleteDoc(doc(db, 'follows', followId(followerUid, followedUid)));
}

export async function countFollowers(uid) {
  if (!db) return 0;
  const s = await getCountFromServer(query(collection(db, 'follows'), where('followedUid', '==', uid)));
  return s.data().count;
}

export async function countFollowing(uid) {
  if (!db) return 0;
  const s = await getCountFromServer(query(collection(db, 'follows'), where('followerUid', '==', uid)));
  return s.data().count;
}

// uids of everyone this user follows — powers the Community "Following" filter.
export async function fetchFollowingUids(uid) {
  if (!db || !uid) return [];
  const snap = await getDocs(query(collection(db, 'follows'), where('followerUid', '==', uid)));
  return snap.docs.map(d => d.data().followedUid).filter(Boolean);
}
